.buttonsDiv {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  margin: auto;
  color: var(--primary-100);
}

.previewCell {
  background-color: var(--color-ffffff);
  border-radius: 30px;
  padding: 5px;
}
